export default {
  notification: {
    success: {
      reply: '¡Tweet respondido con éxito!',
      remove: '¡Página removida con éxito!',
    },
    error: {
      reply: '¡Error al responder al tweet!',
      remove: '¡Error al eliminar la página!',
    },
  },
  label: {
    pageSession: 'Seleccione a página para responder:',
    pageLabel: 'Páginas',
    suggestionSession: 'Genere sugerencias de respuesta vía chatGPT:',
    replySession: 'Edite la sugerencia seleccionada o escriba una respuesta:',
    replyLabel: 'Responder @{username}',
    rules: {
      minChar: 'Se requiere un mínimo de {minChar} caracteres',
      maxChar: 'Se permite un máximo de {maxChar} caracteres',
    },
    button: {
      generateSuggestions: 'Generar Sugerencias',
      reply: 'Responder',
      remove: 'Eliminar',
    },
    status: {
      withoutData: 'Ninguna publicación encontrada',
      errorData: 'Error al realizar su solicitud.',
    },
    closeLabel: 'Cerrar',
  },
  faq: {
    question: '¿Por qué solo puedo responder directamente a las publicaciones de Twitter (X) a través del componente?',
    response: 'Debido a las limitaciones de las APIs de otras redes sociales, no está permitido crear comentarios en publicaciones de otras redes. Esta funcionalidad solo está disponible para la red social X (Twitter).',
  },
};
